import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, catchError, tap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class AddJobEffect {
    addJob$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.addJob),
            switchMap((action) => {
                return this.liveNursesService.addJob(action.job).pipe(
                    mergeMap((job) => [
                        actions.modifyingJobs({ isBusy: true }),
                        actions.addJobSuccess({ jobs: [job || action.job], submittalId: action.submittalId }),
                        actions.loadJobOptions({ submittalIds: [action.submittalId] }),
                        actions.modifyingJobs({ isBusy: false })
                    ]),
                    catchError((error) => of(actions.addJobFail({ error })))
                );
            })
        )
    );

    addJobFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.addJobFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while adding a job.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        protected liveNursesService: LiveNursesService,
        private toaster: ToasterService
    ) {}
}
